'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _resources = require('redux/modules/resources');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module2Extra2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}, { changeResource: _resources.changeResource }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Extra2, _Component);

  function Module2Extra2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Extra2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Extra2.__proto__ || (0, _getPrototypeOf2.default)(Module2Extra2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Meal planning',
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.handleOnClick = function (module, item, page, event) {
      console.log(event);
      _this.props.changeResource(module, item, page);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // used to navigate to a resource item


  (0, _createClass3.default)(Module2Extra2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'By planning your meals you can:'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Make sure you always have vegetables in the house which are washed, chopped up and ready to eat'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Offer at least one fruit or vegetable with each meal and snack - this way, there is less pressure at dinnertime for kids to eat all their vegies, as you know they have eaten at least some throughout the day. Eg. When serving a sandwich for lunch, provide cut up vegie sticks and/or a piece of fruit to go with it.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'When children see you eating vegies, they are more likely to eat them too! It is important to have vegies ready to eat so that you are more likely to eat them when you feel hungry.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Planning meals and snacks means you will also have enough fruit and vegies to put into your family\'s meals.'
              )
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Save yourself time!'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'You can save time in the supermarket by knowing exactly what you need to buy. Planning will also save you from extra trips to the shops for things you have forgotten.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'It can also take effort out of wondering what to make for dinner every night.'
              )
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Save yourself money'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'It is easier to stick to a budget if you plan your meals ahead of time'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'You are less likely to spend money on unexpected take-away meals or non-core food when you go through the checkout'
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer40 })
        )
      );
    }
  }]);
  return Module2Extra2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  changeResource: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module2Extra2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Extra/Extra2.js
// module id = 1194
// module chunks = 0